var getCurrentScreenOrientation = function getCurrentScreenOrientation() {
  var screenOrientation = typeof window !== 'undefined' && window.screen.orientation && window.screen.orientation.type ? window.screen.orientation.type.split('-')[0] : undefined;
  return screenOrientation || (typeof window !== 'undefined' && window.screen.width >= 1024 ? 'landscape' : 'portrait');
};
export default getCurrentScreenOrientation;